import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=7d0ab9d0&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0ab9d0')) {
      api.createRecord('7d0ab9d0', component.options)
    } else {
      api.reload('7d0ab9d0', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=7d0ab9d0&", function () {
      api.rerender('7d0ab9d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/Page.vue"
export default component.exports